'use client'

import React from 'react';

const LoadingPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-dark-800">
      <div className="text-center">
        <div className="spinner-border animate-spin inline-block w-16 h-16 border-8 border-solid border-purple-500 border-t-transparent rounded-full"></div>
        <p className="mt-4 text-xl dark:text-dark-100 text-gray-700">Уншиж байна...</p>
      </div>
    </div>
  );
};

export default LoadingPage;
